// All available icon types for the biel-icon component
export type IconType = 'bot' | 'sparks' | 'question-mark' | 'user' | 'search' | 'biel';

// Icon types suitable for buttons (excludes user and search)
export type ButtonIconType = 'bot' | 'sparks' | 'question-mark' | 'biel';

// Icon types suitable for AI messages (excludes user and search)
export type AiIconType = 'bot' | 'sparks' | 'question-mark' | 'biel';
